// To be deleted once all calculators are done with currency tier-1 adoptions
/**
 * Dependencies
 */

import React from 'react';

import classnames from 'classnames';

// Utils
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { AdvertiserDisclosure, EditorialStandards } from '@nerdwallet/currency';

// Local Components
import Title from '../title/title';
import TwoPanelContainer from '../two-panel-container/two-panel-container';

// CSS
require('./results.less');

const Results = ({
  additionalContent,
  className,
  controlPanel,
  children,
  data,
  fthbNav,
  heading,
  lenders,
  membershipCta,
  methodology,
  onboarding,
  relatedArticles,
  resultsPanel,
  split,
  title,
  subcopy,
  toolLinkCards,
}) => {
  const twoPanelProps = {
    className: classnames({ zoomed: data?.zoomed }),
    primaryPanelProps: {
      className: 'hac-primary',
      children: resultsPanel,
    },
    secondaryPanelProps: {
      className: 'hac-secondary',
      children: controlPanel,
    },
    split,
  };

  // If the data property is empty - the reducer hasn't be set up yet.
  if (isEmpty(data)) {
    return <div />;
  }

  // eslint-disable-next-line jsx-a11y/heading-has-content -- directive added automatically by Shepherd migration
  const pageTitle = title || <Title title={heading} subcopy={subcopy} />;

  return (
    <div>
      <div className="results-wrapper">
        {fthbNav}
        <div className={classnames('hac-wrapper', className)}>
          <div className="hac-results-container">
            <div className="advertiser-disclosure">
              <AdvertiserDisclosure
                enableAnalytics={{ onClick: true, onHover: false }}
              />
            </div>
            {onboarding}
            {pageTitle}
            <TwoPanelContainer {...twoPanelProps} />
            {lenders && <EditorialStandards className="editorial-standards" />}
            {lenders}
            {membershipCta}
            {children}
          </div>
          {methodology}
        </div>
      </div>
      {relatedArticles}
      {toolLinkCards}
      {additionalContent}
    </div>
  );
};

Results.displayName = 'Results';

Results.propTypes = {
  additionalContent: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  controlPanel: PropTypes.node,
  data: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fthbNav: PropTypes.node,
  heading: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
  lenders: PropTypes.node,
  locationDetails: PropTypes.node,
  membershipCta: PropTypes.node,
  methodology: PropTypes.node,
  onboarding: PropTypes.node,
  relatedArticles: PropTypes.node,
  resultsPanel: PropTypes.node.isRequired,
  route: PropTypes.object.isRequired,
  split: PropTypes.string,
  subcopy: PropTypes.node,
  title: PropTypes.node,
  toolLinkCards: PropTypes.node,
};

Results.defaultProps = {
  split: '66%',
  additionalContent: null,
  children: null,
  className: null,
  controlPanel: null,
  fthbNav: null,
  heading: null,
  lenders: null,
  locationDetails: null,
  membershipCta: null,
  methodology: null,
  onboarding: null,
  relatedArticles: null,
  subcopy: null,
  title: null,
  toolLinkCards: null,
};

export default Results;
